<template>
  <div>
    <component
      :is="reactionComponent"
      :message="message"
      @thumbDown="thumbDown"
      @thumbUp="thumbUp"
    />
  </div>
</template>

<script>
import ThumbUp from './ThumbUp.vue';
import ThumbDown from './ThumbDown.vue';
import ThumbSelector from './ThumbSelector.vue';
import nliApi from '@shared/services/nliApi.js';
import { mapMutations } from 'vuex';
import { SET_MESSAGE_REACTION } from '@src/shared/store/modules/copilot';

export default {
  components: {
    ThumbUp,
    ThumbDown,
    ThumbSelector,
  },
  props: {
    message: {
      type: Object,
      required: true,
    },
  },
  computed: {
    reactionComponent() {
      const reaction = this.message?.reaction;
      if (reaction === 1) {
        return 'ThumbUp';
      } else if (reaction === 2) {
        return 'ThumbDown';
      } else if (reaction === 0) {
        return 'ThumbSelector';
      }
    },
  },
  methods: {
    async submitReaction(reaction) {
      const message = this.message;
      if (message) {
        const response = await nliApi.updateMessage(message.id, {
          reaction: reaction,
        });
        const responseReaction = response?.updated_message?.reaction || 0;
        this.handleReactionSelection({
          id: message.id,
          reaction: responseReaction,
        });
      }
    },
    async thumbUp() {
      this.submitReaction(1);
    },
    async thumbDown() {
      this.submitReaction(2);
    },
    ...mapMutations({
      handleReactionSelection: `copilot/${SET_MESSAGE_REACTION}`,
    }),
  },
};
</script>
